<template>
  <a-layout class="main-view">
    <div class="loading-mask" v-if="userAuthLoading">
      <a-spin />
    </div>
    <template v-else>
      <a-layout-sider :collapsible="false" :width="120">
        <a-menu
          theme="dark"
          mode="vertical"
          :selectedKeys="selectedKeys"
        >
          <a-menu-item
            v-for="router in routerConfig"
            :key="router.name"
          >
            <Router-link :to="{name: router.name}">{{ router.title }}</Router-link>
          </a-menu-item>
        </a-menu>
      </a-layout-sider>

      <a-layout>
        <a-layout-header class="header">
          <div class="logout" @click="logout"><a-icon type="user" /> 退出登录</div>
        </a-layout-header>
        <div class="content">
          <router-view></router-view>
        </div>
      </a-layout>
    </template>
  </a-layout>
</template>

<script>
import { mainRoute } from '@/config/router.config';
import { getUser } from "@/apis";

export default {
  data() {
    return {
      userAuthLoading: true,
      routerConfig: mainRoute.children,
      title: process.env.VUE_APP_TITLE,
    };
  },
  computed: {
    selectedKeys() {
      return [this.$route.name];
    },
  },
  mounted() {
    this.checkUserLogin();
  },
  methods: {
    async checkUserLogin() {
      await getUser();
      this.userAuthLoading = false;
    },
    logout() {
      window.location.href = `${window.location.origin}/api/logout`;
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-mask {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-view {
  min-height: 100%;
}

.content {
  background-color: white;
  padding: 20px;
}

.header {
  height: 40px;
  background-color: white;
  border-bottom: 1px solid #ccc;
}

.logout {
  font-size: 12px;
  line-height: 40px;
  float: right;
  padding: 0 10px;
  cursor: pointer;

  &:hover {
    background-color: #eee;
  }
}
</style>
